import React from 'react';

const columns = [
  {
    heading: 'Product',
    links: [
      { name: 'For teachers', href: '/' },
      { name: 'For students', href: '/students' },
      { name: 'How it works', href: '/students#st-steps-h' },
      { name: 'Results', href: '/testimonials' },
      { name: 'All testimonials', href: '/testimonials' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { name: 'About Us', href: '/about#top' },
      { name: 'Partners', href: '/for-schools#sch-marquee-line' },
      { name: 'Contact', href: '/contact' },
      { name: 'FAQ', href: '/faq' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { name: 'Privacy Policy', href: '/privacy-policy' },
      { name: 'Terms of Service', href: '/terms-of-service' },
      { name: 'Acceptable Use', href: '/acceptable-use' },
    ],
  },
];

// innerClassName: pages with wider content edges pass their own column (the
// teacher landing preview uses 1200px); every other page keeps max-w-6xl.
const FooterV2 = ({ innerClassName = 'max-w-6xl' }) => (
  <footer className="bg-ink text-white py-16 px-4" data-nav-dark>
    <div className={`${innerClassName} mx-auto grid grid-cols-1 md:grid-cols-4 gap-10`}>
      <div>
        {/* 600, not bold: USE-THIS-UI section 6 bans font-bold (Sandy OK'd 2026-09-29). */}
        <div className="text-xl font-semibold mb-4">Brain Buffs</div>
        <p className="text-sm text-neutral-400 leading-relaxed [text-wrap:pretty]">
          SAT® is a trademark registered by the College Board, which is not affiliated with, and does not endorse,
          this product.
        </p>
        <p className="text-sm text-neutral-500 mt-4">© {new Date().getFullYear()} Brain Buffs Tutoring LLC</p>
      </div>
      {columns.map((col) => (
        <div key={col.heading}>
          {/* The links are 44px tap targets, so the rows carry their own air:
              no list gap, and a smaller heading margin (the link's own top
              padding finishes the space under the heading). */}
          <div className="font-semibold mb-2">{col.heading}</div>
          <ul className="list-none p-0 m-0">
            {col.links.map((l) => (
              <li key={l.name}>
                <a href={l.href} className="inline-flex items-center min-h-[44px] text-sm text-neutral-400 hover:text-white no-underline transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-white">
                  {l.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </footer>
);

export default FooterV2;
